import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=641b05ca&scoped=true"
import script from "./DialogForm.vue?vue&type=script&lang=js"
export * from "./DialogForm.vue?vue&type=script&lang=js"
import style0 from "./DialogForm.vue?vue&type=style&index=0&id=641b05ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b05ca",
  null
  
)

export default component.exports